import angular from 'angular'
import includes from 'lodash/includes'
import trim from 'lodash/trim'
import { VD_KEY_CODES } from '../../constants'

import template from './vd-tag-input.html'

angular.module('vend.ui').directive('vdTagInput', function (elementService) {
  return {
    scope: {
      markedDeletion: '<',
      tags: '=',
    },
    template,
    bindToController: true,
    controllerAs: 'vdTagInputCtrl',
    link(scope, $element, attrs) {
      const classes = elementService.getClasses($element)
      const tagInput = $element[0].querySelector('.vd-lozenge-group-input')

      classes.push('vd-lozenge-group')

      scope.vdTagInputCtrl.placeholder = attrs.placeholder

      attrs.$set('class', classes.join(' '))

      $element.on('click', () => {
        tagInput.focus()
      })
    },
    controller($scope, $element, $timeout) {
      const ctrl = this
      const ADD_TAG_KEY_CODES = [VD_KEY_CODES.ENTER, VD_KEY_CODES.COMMA]

      /**
       * Handles the animation of an already added tag.
       *
       * @method _alreadyAddedHandler
       * @param  {String} trimmedVal
       *         The trimmed value of the tag attempted to be added.
       */
      function _alreadyAddedHandler(trimmedVal) {
        let alreadyAddedTag

        $element[0].querySelectorAll('.vd-lozenge').forEach(tagEl => {
          const tagNode = angular.element(tagEl)
          const tagText = angular.element(
            tagEl.querySelector('.vd-lozenge-value')
          )

          tagNode.removeClass('vd-lozenge-group-already-added')

          if (tagText.text().trim() === trimmedVal) {
            alreadyAddedTag = tagNode
          }
        })

        $timeout(() =>
          alreadyAddedTag.addClass('vd-lozenge-group-already-added')
        )
      }

      /**
       * Adds the focus class to the tag input container, so has the same focus styles like vd-inputs.
       *
       * @method handleFocus
       */
      ctrl.handleFocus = () => {
        $element.addClass('vd-focus')
      }

      /**
       * Removes the focus class and checks if there is any remaining values in the input. If so, add it as a tag.
       *
       * @method handleBlur
       */
      ctrl.handleBlur = () => {
        const tags = ctrl.tags
        const inputNode = $element.find('input')
        const trimmedVal = trim(inputNode.val())

        $element.removeClass('vd-focus')

        if (trimmedVal && !tags.some(tag => tag.value === trimmedVal)) {
          ctrl.tags.push({
            value: trimmedVal,
          })

          inputNode.val('')
        }
      }

      /**
       * Handle keypresses that should trigger extra functionality
       *
       * @method handleKeypress
       * @param  {Event} event
       */
      ctrl.handleKeypress = event => {
        const tags = ctrl.tags
        const inputNode = $element.find('input')
        const inputVal = inputNode.val()
        const trimmedVal = trim(inputVal)
        const keyCode = event.keyCode

        if (includes(ADD_TAG_KEY_CODES, keyCode) && trimmedVal) {
          if (!tags.some(tag => tag.value === trimmedVal)) {
            ctrl.tags.push({
              value: trimmedVal,
            })

            inputNode.val('')

            // Preventing default so the character isn't added to the input field (e.g. in the case of comma)
            event.preventDefault()
          } else {
            _alreadyAddedHandler(trimmedVal)
          }
        } else if (
          keyCode === VD_KEY_CODES.BACKSPACE &&
          !inputVal &&
          tags.length
        ) {
          if (!this.markedDeletion) {
            ctrl.tags.pop()
          }
        } else if (keyCode === VD_KEY_CODES.ENTER) {
          // Preventing default and propagation on enter key press, as if this is nested in a form, the submit handler
          // will fire.
          event.stopPropagation()
          event.preventDefault()
        }
      }

      /**
       * Removes the tag from passed index.
       *
       * @method removeTag
       * @param index {Number}
       *        The index of the entity to remove.
       */
      ctrl.removeTag = index => {
        if (this.markedDeletion) {
          ctrl.tags[index].marked = !ctrl.tags[index].marked
        } else {
          ctrl.tags.splice(index, 1)
        }
      }

      /**
       * Removes all tags.
       *
       * @method removeAllTags
       */
      ctrl.removeAllTags = () => {
        ctrl.tags = []
      }
    },
  }
})
